import { useProviderTheme } from '../contexts/ProviderThemeContext';

export default function ProviderThemeLogo({ src, darkSrc, alt, ...props }) {
    const providerTheme = useProviderTheme();
    const isDark = providerTheme?.enabled && providerTheme.theme === 'dark';
    return <img {...props} alt={alt} src={isDark ? darkSrc : src} />;
}
